import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout.vue'
import store from '../store'
import Home from '../views/Home'
import Candidates from '../views/Candidates.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
   component: Layout,
    children: [
      { 
        path: '',
        name: 'candidates',
        component: resolve => resolve(Candidates)
      },
    ]
    },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: () =>
  //     import('@/views/Login')
  // },
  {
    path: '/candidates',
    component: Layout,
    children: [
      { 
        path: '',
        name: 'candidates',
        component: resolve => resolve(Candidates)
      },
    ]
  },
  {
    path: '/profile',
    component: Layout,
    children: [
      { 
        path: '',
        name: 'profile',
        component: () => import('@/views/Profile.vue')
      },
    ]
  },
  {
    path: '/search-candidates',
    component: Layout,
    children: [
      { 
        path: '',
        name: 'search-candidates',
        component: () => import('@/views/SearchCandidates.vue')
      },
    ]
  },
  {
    path: '/add-candidate',
    component: Layout,
    children: [
      { 
        path: '',
        name: 'add-candidate',
        component: () => import('@/views/AddCandidate.vue')
      },
    ]
  },
  {
    path: '/my-candidate',
    component: Layout,
    children: [
      { 
        path: '',
        name: 'my-candidates',
        component: () => import('@/views/MyCandidates.vue')
      },
    ]
  },

  {
    path: '/users',
    component: Layout,
    children: [
      {
        path: '/',
        component: () =>
          import('@/views/users/Users'),
        meta: {
          permission: "users-show"
        }
      }
    ]
  },
  {
    path: '/404',
    component: () =>
      import('@/views/layouts/404'),
    visible: true, //store.getters.checkPermission("templates-index")
  },
  {
    path: '/403',
    component: () =>
      import('@/views/layouts/403'),
  },
  {
    path: '*',
    redirect: '/candidates',
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

// router.beforeEach((to, from, next) => {
//   var access_token = store.getters.getAccessToken();
//   let localStorage = window.localStorage;
//   const now = new Date();
//   let expire_token = localStorage.getItem('expire_token', now.getTime());

//   if (!(expire_token == 'null' || expire_token == null) && expire_token < now.getTime() - 10800000 && to.fullPath != '/login') {
//     store.dispatch("setUser", null);
//     store.dispatch("setPermissions", null);
//     store.dispatch("setAccessToken", null);
//     next({
//       path: '/login',
//     })
//   }


//   if (!access_token && to.fullPath != '/login') {
//     store.dispatch('setRedirectUrl', to.fullPath);
//     localStorage.setItem('expire_token', now.getTime());
//     next({
//       path: '/login',
//     })
//   } else if (!to.meta.permission || store.getters.checkPermission(to.meta.permission)) {
//     localStorage.setItem('expire_token', now.getTime());
//     next()
//   } else {
//     localStorage.setItem('expire_token', now.getTime());
//     next('/403')
//   }
// })

export default router
